// import Main from '@/view/main'

export default {
  path: 'cms',
  meta: {
    title: '内容管理'
  },
  component: () => import('@/components/parent-view'),
  name: 'cms',
  children: [
	  {
	    path: 'fixed',
	    name: 'price-fixed',
	    meta: {
	      title: '价格指数维护'
	    },
	    component: () => import('@/view/cms/price-fixed')
	  },
    {
      path: 'floor',
      name: 'cms-floor',
      meta: {
        title: '楼层管理'
      },
      component: () => import('@/view/cms/floor')
    },
    {
      path: 'tag',
      name: 'cms-label-index',
      meta: {
        title: '标签管理'
      },
      component: () => import('@/view/cms/tag')
    },
    {
      path: 'news',
      name: 'cms-news-index',
      meta: {
        title: '资讯管理'
      },
      component: () => import('@/view/cms/news')
    },
    {
      path: 'news/add',
      name: 'cms-news-add',
      meta: {
        title: '新增资讯',
        hideInTabBar: true
      },
      component: () => import('@/view/cms/news/edit.vue')
    },
    {
      path: 'news/edit',
      name: 'cms-news-edit',
      meta: {
        title: '资讯编辑',
        hideInTabBar: true
      },
      component: () => import('@/view/cms/news/edit.vue')
    },
    {
      path: 'news/detail/:id',
      name: 'cms-news-detail',
      meta: {
        title: '资讯详情',
        hideInTabBar: true
      },
      component: () => import('@/view/cms/news/detail.vue')
    },
    {
      path: 'help',
      name: 'cms-help-index',
      meta: {
        title: '帮助中心管理'
      },
      component: () => import('@/view/cms/help')
    },
    {
      path: 'help/add',
      name: 'cms-help-add',
      meta: {
        title: '新增帮助信息',
        hideInTabBar: true
      },
      component: () => import('@/view/cms/help/edit.vue')
    },
    {
      path: 'help/edit',
      name: 'cms-help-edit',
      meta: {
        title: '编辑帮助信息',
        hideInTabBar: true
      },
      component: () => import('@/view/cms/help/edit.vue')
    },
    {
      path: 'help/detail/:id',
      name: 'cms-help-detail',
      meta: {
        title: '帮助信息详情',
        hideInTabBar: true
      },
      component: () => import('@/view/cms/help/detail.vue')
    },
    {
      path: 'notice',
      name: 'cms-notice-index',
      meta: {
        title: '公告管理'
      },
      component: () => import('@/view/cms/notice')
    },
    {
      path: 'notice/add',
      name: 'cms-notice-add',
      meta: {
        title: '新增公告',
        hideInTabBar: true
      },
      component: () => import('@/view/cms/notice/edit.vue')
    },
    {
      path: 'notice/edit',
      name: 'cms-notice-edit',
      meta: {
        title: '编辑公告',
        hideInTabBar: true
      },
      component: () => import('@/view/cms/notice/edit.vue')
    },
    {
      path: 'notice/detail/:id',
      name: 'cms-notice-detail',
      meta: {
        title: '公告详情',
        hideInTabBar: true
      },
      component: () => import('@/view/cms/notice/detail.vue')
    },
    {
      path: 'ad',
      name: 'cms-ad-index',
      meta: {
        title: '广告管理'
      },
      component: () => import('@/view/cms/ad')
    },
    {
      path: 'ad/add',
      name: 'cms-ad-add',
      meta: {
        title: '新增广告',
        hideInTabBar: true
      },
      component: () => import('@/view/cms/ad/edit.vue')
    },
    {
      path: 'ad/edit',
      name: 'cms-ad-edit',
      meta: {
        title: '编辑广告',
        hideInTabBar: true
      },
      component: () => import('@/view/cms/ad/edit.vue')
    },
    {
      path: 'element',
      name: 'crm-element',
      meta: {
        title: '元素管理'
      },
      component: () => import('@/view/cms/element')
    },
    {
      path: 'about',
      name: 'cms-about-index',
      meta: {
        title: '关于我们管理'
      },
      component: () => import('@/view/cms/about')
    },
    {
      path: 'about/add',
      name: 'cms-about-add',
      meta: {
        title: '新增关于我们',
        hideInTabBar: true
      },
      component: () => import('@/view/cms/about/edit.vue')
    },
    {
      path: 'about/edit',
      name: 'cms-about-edit',
      meta: {
        title: '编辑关于我们',
        hideInTabBar: true
      },
      component: () => import('@/view/cms/about/edit.vue')
    },
    {
      path: 'about/detail/:id',
      name: 'cms-about-detail',
      meta: {
        title: '关于我们详情',
        hideInTabBar: true
      },
      component: () => import('@/view/cms/about/detail.vue')
    },
    {
      path: 'param',
      meta: {
        title: '参数管理'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'cms-param',
          meta: {
            title: '参数管理',
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/cms/params/index.vue')
        },
        {
          path: 'edit/:id',
          name: 'cms-param-edit',
          meta: {
            title: '编辑参数',
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/cms/params/edit.vue')
        }
      ]
    },
    {
      path: 'file',
      name: 'cms-file',
      meta: {
        title: '文件上传'
        // ignoreBreadCrumb: true
      },
      component: () => import('@/view/cms/file/index.vue')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/cms.js